import React from 'react';
import { Request } from '@oscar/request';
import { RequestParams, TableOptions } from './typed';

export interface TableContextProps {
  options?: TableOptions;
  doAction?: (request: Request, data: any) => void;
  fetchData?: (params?: RequestParams) => void;
  reloadData?: (params?: RequestParams) => void;
  getMetadata?: () => RequestParams;
}

export const TableContext = React.createContext<TableContextProps>({});
